import { API_URL } from '../../../app-config/constants';
import type Feature from '../../../types/Feature';
import { get } from '../request';

getAllKnownFlags.operation = 'READ';
export function getAllKnownFlags() {
    return get<Feature[]>(`${API_URL}/feature-flag/all-known`);
}
